/**
 * moonshot-cart-split-ui.js
 *
 * UI controller for the cart-page split flow. Liquid renders
 * `snippets/moonshot-cart-split.liquid` when the cart is mixed; this
 * file wires the "Continue — start with shipping" button to
 * window.MoonshotSplit.startSplit() and shows a loading state during
 * the cart mutation.
 *
 * Pure DOM glue — no state of its own. The state machine lives in
 * moonshot-split-checkout.js.
 */
(function () {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  function init() {
    const cta = document.querySelector("[data-moonshot-cart-split-cta]");
    if (!cta) return;
    if (cta.dataset.moonshotBound === "1") return;
    cta.dataset.moonshotBound = "1";

    const labelEl = cta.querySelector("[data-moonshot-cart-split-cta-label]") || cta;
    const originalLabel = labelEl.textContent;

    cta.addEventListener("click", async function (e) {
      e.preventDefault();
      if (cta.disabled) return;
      cta.disabled = true;
      labelEl.textContent = "One moment…";
      try {
        if (!window.MoonshotSplit || typeof window.MoonshotSplit.startSplit !== "function") {
          throw new Error("Split orchestrator unavailable. Please refresh.");
        }
        await window.MoonshotSplit.startSplit();
        // startSplit() redirects; if it returns we got an unexpected state.
      } catch (err) {
        console.error("[moonshot-cart-split-ui] startSplit failed:", err);
        labelEl.textContent = originalLabel;
        cta.disabled = false;
        // Surface to the customer minimally.
        alert(
          "Couldn't start the shipping order — please refresh and try again. " +
            "If this keeps happening, contact us.",
        );
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
